var _path, _path2, _path3, _path4, _path5, _path6, _path7, _path8, _path9, _path10, _path11;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgSurveyTeamLeader({
  title,
  titleId,
  ...props
}, svgRef) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 129,
    height: 98,
    viewBox: "0 0 129 98",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M.5 0h128v98H.5V0z",
    fill: "#5959EB"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M7.5 17h114v74H7.5V17z",
    fill: "#fff"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M12.5 9a3 3 0 1 1-6 0 3 3 0 0 1 6 0z",
    fill: "#19D89F"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M21.5 9a3 3 0 1 1-6 0 3 3 0 0 1 6 0z",
    fill: "#FED730"
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    d: "M30.5 9a3 3 0 1 1-6 0 3 3 0 0 1 6 0z",
    fill: "#BF3DC2"
  })), _path6 || (_path6 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M109.371 33.57c.826.773.84 2.04.032 2.829L94.439 51.012l-13.621-7.57-12.367 10.08c-.879.716-2.2.616-2.95-.224a1.939 1.939 0 0 1 .234-2.82l14.623-11.92 13.369 7.43 12.684-12.387a2.163 2.163 0 0 1 2.96-.03z",
    fill: "#000"
  })), _path7 || (_path7 = /*#__PURE__*/React.createElement("path", {
    d: "M72 52a6 6 0 1 1-12 0 6 6 0 0 1 12 0z",
    fill: "#424F9C"
  })), _path8 || (_path8 = /*#__PURE__*/React.createElement("path", {
    d: "M115.5 34a6 6 0 1 1-12 0 6 6 0 0 1 12 0z",
    fill: "#19D89F"
  })), _path9 || (_path9 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M51.5 41.086C51.5 32.754 44.746 26 36.414 26v15.086H51.5z",
    fill: "#BF3DC2"
  })), _path10 || (_path10 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M33.586 28.357c-8.332 0-15.086 6.754-15.086 15.086s6.754 15.086 15.086 15.086c8.331 0 15.085-6.755 15.085-15.086H33.586V28.357z",
    fill: "#000"
  })), _path11 || (_path11 = /*#__PURE__*/React.createElement("path", {
    d: "M18.5 68h94v13h-94V68z",
    fill: "#F8D856"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgSurveyTeamLeader);
export default __webpack_public_path__ + "static/media/survey-team-leader.1d519feaecf21bc7143afdc95aa23765.svg";
export { ForwardRef as ReactComponent };